import { ServiceModel } from '@truckdown/systems';
import { defineComponent, ref, Ref, computed, onMounted } from 'vue';

export default defineComponent({
    props: {
        services: {
            type: Array as () => ServiceModel[],
            required: true
        }
    },
    emits: [],
    setup: function (props, ctx) {
        return {
        };
    }
});

